import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Wording } from "./process-report-table-wording";
import { IPaginationRecordset } from "libraries/component/pagination/IPagination";
import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import {
    ENavigationDirection,
    INavigationOutput
} from "app_sasha/pages/process-report/components/process-report-table/process-report-table.component";
import { faAngleDoubleLeft, faAngleDoubleRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FormControl, FormGroup } from "@angular/forms";
import { ISimpleSelectFieldConfig } from "libraries/module/formbuilder/fields/simple-select/simple-select.interface";
import { IProcessReportSearchParams } from "app_sasha/pages/process-report/process-report-page.component";

@Component({
    selector: 'process-report-pagination',
    template: `
        <btn [value]="wording.prev"
             [disableIf]="!(responseRecordSet?.contextPrevId | isTruely)"
             [type]="btnType.actionLink"
             (onClick)="navigate(directionList.prev)">
            <fa-icon class="icon" [icon]="iconPrev"></fa-icon>
        </btn>

        <multiselect [fieldConfig]="fieldConfig"
                     [options]="fieldConfig.options"
                     [maxSelection]="1"
                     [showHeader]="false"></multiselect>

        <btn [value]="wording.next"
             [disableIf]="!(responseRecordSet?.contextNextId | isTruely)"
             [type]="btnType.actionLink"
             (onClick)="navigate(directionList.next)">
            <fa-icon class="icon-end" [icon]="iconNext"></fa-icon>
        </btn>
    `,
    styles: [`
        :host {
            display: flex;
            padding: .325rem .75rem;
        }

        simple-select {
            width: 75px;
            margin-left: .75rem;
            margin-right: .75rem;
        }
    `]
})

export class ProcessReportPaginationComponent implements OnChanges, OnInit {

    @Input()
    public responseRecordSet: IPaginationRecordset;
    @Input()
    public params: IProcessReportSearchParams;
    @Output()
    public readonly onNavigate: EventEmitter<INavigationOutput> = new EventEmitter<INavigationOutput>();

    public wording: Wording = new Wording();
    public btnType: typeof BtnStyleTypes = BtnStyleTypes;
    public count: number = 50;
    public directionList: typeof ENavigationDirection = ENavigationDirection;
    public iconPrev: IconDefinition = faAngleDoubleLeft;
    public iconNext: IconDefinition = faAngleDoubleRight;
    public fieldConfig: ISimpleSelectFieldConfig;
    private formGroup: FormGroup;
    private outputValue: INavigationOutput = {};

    public ngOnInit(): void {
        this.formGroup = new FormGroup({
            count: new FormControl([this.responseRecordSet?.count?.toString()])
        });
        this.fieldConfig = {
            formGroup: this.formGroup,
            formControlName: 'count',
            disabled: this.responseRecordSet?.all,
            options: [
                {
                    value: '50',
                    label: '50',
                },
                {
                    value: '100',
                    label: '100',
                },
            ],
        };

        this.formGroup.valueChanges
            .subscribe({
                next: (value: INavigationOutput): void => {
                    if (value.count) {
                        const count: string = Array.isArray(value.count) ? value.count[0] : value.count;
                        this.count = Number(count);
                        if (!this.responseRecordSet.contextPrevId) {
                            this.outputValue = {
                                count: this.count,
                            };
                        } else {
                            this.outputValue = {
                                ...this.outputValue,
                                count: this.count,
                            };
                        }

                        this.onNavigate.emit(this.outputValue);
                    }
                },
            });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.params.currentValue) {
            const params: IProcessReportSearchParams = changes.params.currentValue;
            this.count = params.pcount;
            this.outputValue = {
                count: this.count
            };
            if (params.pnext) {
                this.outputValue.direction = ENavigationDirection.next;
                this.outputValue.id = params.pnext;
            }
            if (params.pprev) {
                this.outputValue.direction = ENavigationDirection.prev;
                this.outputValue.id = params.pprev;
            }
            // if (this.formGroup) {
            //     this.formGroup.patchValue(
            //         {count: [this.count.toString()]},
            //         {onlySelf: true, emitEvent: false}
            //     );
            // }
        }
    }

    public navigate(direction: ENavigationDirection): void {
        this.outputValue = {
            direction,
            count: this.count,
            id: direction === ENavigationDirection.prev ? this.responseRecordSet.contextPrevId : this.responseRecordSet.contextNextId,
        };
        this.onNavigate.emit(this.outputValue);
    }
}
